import { useState } from "react"
import type * as FirebaseAuth from "firebase/auth"
import { Button, Stack } from "react-bootstrap"
import { api, firestore } from "../../core"
import { useToast } from "popopo-lib-front/hook"
import { usePublicInitialLooks } from "popopo-lib-front/firestore-access"
import { UserDocument } from "popopo-msg"
import { SpinnerRow } from "../SpinnerRow"

export const InitialLookDebugForm = (props: { firebase: FirebaseAuth.User; user: UserDocument }) => {
  const toast = useToast()
  const publicInitialLooks = usePublicInitialLooks(firestore)
  const [acquiringId, setAcquiringId] = useState<string | null>(null)

  const alreadyAcquired = props.user.initial_look_item_id !== undefined && props.user.initial_look_item_id !== null

  const acquireInitialLook = async (itemId: string) => {
    setAcquiringId(itemId)
    try {
      const idToken = await props.firebase.getIdToken()
      const res = await api.POST("/api/v2/users/me/user-inventories/{itemId}", {
        params: { path: { itemId } },
        body: { kind: "initial-look" as const, withLookUpdate: true },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
      if (res.error !== undefined) {
        toast.add({
          type: "danger",
          title: "InitialLook 取得に失敗しました",
          message: JSON.stringify(res.error),
        })
        return
      }
      toast.add({
        type: "success",
        title: "InitialLook 取得",
        message: `InitialLook を取得しました (itemId: ${itemId})`,
      })
    } catch (e) {
      console.error(e)
      toast.add({
        type: "danger",
        title: "InitialLook 取得に失敗しました",
        message: e instanceof Error ? e.message : String(e),
      })
    } finally {
      setAcquiringId(null)
    }
  }

  return (
    <Stack gap={2}>
      {alreadyAcquired && (
        <div className="alert alert-info mb-0">
          設定済み: <code>{props.user.initial_look_item_id}</code>
        </div>
      )}
      {publicInitialLooks === "loading" ? (
        <SpinnerRow />
      ) : publicInitialLooks.length === 0 ? (
        <p className="text-muted">選択可能な InitialLook がありません</p>
      ) : (
        <ul className="list-group">
          {publicInitialLooks.map((look) => (
            <li key={look.item_id} className="list-group-item d-flex justify-content-between align-items-center">
              <div>
                <code>{look.item_id}</code>
                <span className="ms-2 text-muted">priority: {look.priority}</span>
              </div>
              <Button
                size="sm"
                variant="outline-primary"
                disabled={acquiringId !== null || alreadyAcquired}
                onClick={() => acquireInitialLook(look.item_id)}
              >
                {acquiringId === look.item_id ? "取得中..." : "取得"}
              </Button>
            </li>
          ))}
        </ul>
      )}
    </Stack>
  )
}
